import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ErrorDisplayManagerService {

  private showErrorSubject = new Subject<Object>();

  constructor() { }

  public fireError(errorName: string) {
    this.showErrorSubject.next({ errorName: errorName });
  }

  public getErrorSubject() {
    return this.showErrorSubject;
  }


}
